export const CONSENT_URL_FIELD = 'consent_url'

// the API cannot read this from the Referer: our calls are cross-site, so the browser trims that header to the bare origin
export function consentCollectionUrl(): string {
    if (typeof window === 'undefined') return ''

    return window.location.origin + window.location.pathname
}

/** Adds the collection URL to a consent payload — the proof partners require alongside the consent itself. */
export function withConsentUrl<T extends Record<string, unknown>>(payload: T): T {
    const url = consentCollectionUrl()

    return url ? { ...payload, [CONSENT_URL_FIELD]: url } : payload
}
